if (!customElements.get('gopuff-collection-carousel')) {
  class GopuffCollectionCarousel extends HTMLElement {
    constructor() {
      super();
      this.loading = false;
      this.products = [];
      this.gopuff_product_ids = [];
      this.breinifyRecommendation = null;
      this.breinifyRecommenderId = this.getAttribute(`breinify-recommender-id`);
      this.recommendationSku = this.getAttribute(`recommendation-sku`);
      this.hideSectionIfProductsEmpty = this.getAttribute(`hide-section-if-products-empty`) == 'true';
      this.hideOutOfStockProducts = this.getAttribute(`hide-out-of-stock-products`) == 'true';
      this.in_stock_products_by_location = this.getAttribute(`in-stock-gopuff-product-ids`)
        ? JSON.parse(this.getAttribute(`in-stock-gopuff-product-ids`))
        : null;

      this.section = this.closest(`[data-section-type]`);
      this.classList.add(`gopuff-collection-carousel`);

      subscribe(PUB_SUB_EVENTS.bevmoLocationUpdate, () => {
        this.loadProducts();
      });
    }

    getRecommendationsSearchBody() {
      const product_id = this.getAttribute(`recommendation-product-id`);

      if (!this.getAttribute(`recommendation-product-id`)) { return null; }

      return {
        product_id,
        limit: Number(this.getAttribute(`per-page`)) || 8,
        intent: this.getAttribute(`recommendation-intent`),
      };
    }

    mapProductToGopuffId(product) {
      if (!product || !product.variants) { return ``; }

      const id_string = product.variants[0].sku;

      return Number(id_string.split(`_`)[0]);
    }

    getGopuffProductIdsFromStr(str = ``) {
      const gopuff_product_ids = str
        .split(`, `).join(`,`).split(`,`)
        .filter((id_string) => { return Number(id_string.split(`_`)[0]) })
        .map((id_string) => { return Number(id_string.split(`_`)[0]) });

      return gopuff_product_ids;
    }

    async getGopuffProductIdsFromProductId() {
      const recommendationsSearchBody = this.getRecommendationsSearchBody();
      const fetch_json_str = JSON.stringify(recommendationsSearchBody);
      const cacheQuery = (element) => element.query === fetch_json_str;
      const existingData = GopuffCollectionCarousel.recommendationsCache.find(cacheQuery);

      if (existingData) {
        return existingData.products.map(this.mapProductToGopuffId);
      }

      try {
        const response = await fetch(`${window.Shopify.routes.root}recommendations/products.json?${new URLSearchParams(recommendationsSearchBody)}`);
        const json = await response.json();
        const products = json.products || [];

        GopuffCollectionCarousel.recommendationsCache.push({ query: fetch_json_str, products });

        return products.map(this.mapProductToGopuffId);
      } catch (error) {
        console.error(`error getting shopify product recommendations`, error);

        return [];
      }
    }

    async getBreinifyRecommendation() {
      const recommendation = {};

      if (!this.breinifyRecommenderId) { return recommendation; }

      const cart = await document.querySelector(`cart-drawer-items`).getCartJSON();
      const inCartGopuffSkus = cart.items.map((item) => {
        if (!item.sku) { return ``; }

        const gopuffSku = item.sku.split(`_`)[2];

        return gopuffSku;
      }).filter(Boolean);

      const recommendationParams = {
        namedRecommendations: [this.breinifyRecommenderId],
        recommendationQueryName: this.breinifyRecommenderId,
        recommendationForItems: this.recommendationSku ? [this.recommendationSku] : inCartGopuffSkus,
      };

      const { result: results, additionalData = {} } = await window.gopuffBreinify.getRecommendations(recommendationParams);

      if (!results) { return recommendation; }

      const gopuffProductIds = results.map((result) => {
        const productUrl = result.additionalData[`product::productUrl`];

        if (!productUrl) { return ``; }

        const gopuffProductId = productUrl.split(`/products/`)[1].split(`-`)[0];

        return Number(gopuffProductId);
      }).filter(Boolean);

      recommendation.products = gopuffProductIds;

      if (additionalData.title) {
        recommendation.title = additionalData.title;
      }

      if (additionalData.ctaUrl && additionalData.ctaText) {
        recommendation.cta = {
          url: additionalData.ctaUrl,
          text: additionalData.ctaText,
        }
      }

      return recommendation;
    }

    async getGopuffProductIds() {
      const gopuffProductIdsStr = Boolean(this.in_stock_products_by_location && bevmoLocation.location_id)
        ? this.in_stock_products_by_location[bevmoLocation.location_id]
        : this.getAttribute(`gopuff-product-ids`);

      if (gopuffProductIdsStr) {
        return this.getGopuffProductIdsFromStr(gopuffProductIdsStr);
      }

      if (this.breinifyRecommenderId) {
        this.breinifyRecommendation = await this.getBreinifyRecommendation();

        return this.breinifyRecommendation.products || [];
      }

      if (this.getAttribute('recommendation-product-id') !== null) {
        return await this.getGopuffProductIdsFromProductId();
      }

      return [];
    }

    getSearchBody() {
      const filters = {};
      const selected_taxonomy = ``;
      const sort_by = `BEST_MATCH`;
      const per_page = this.getAttribute(`per-page`) || 8;
      const taxonomy = this.getAttribute(`taxonomy-id`) || ``;

      const adParams = !PromotedProductsIntegration.adsEnabled()
      ? {}
      : {
        adSessionId: PromotedProductsIntegration.getAdSessionId(),
        pageType:  PromotedProductsIntegration.getPageType(),
        contentRequestId: PromotedProductsIntegration.getContentRequestId(),
        userId: PromotedProductsIntegration.getUserId()
      }

      if (!taxonomy && this.gopuff_product_ids.length === 0) {
        return {};
      }

      const { fulfillment_type, location_id } = window.bevmoLocation;

      const search_body = {
        fulfillment_type,
        selected_taxonomy,
        location_id,
        filters,
        sort_by,
        per_page,
        ...adParams
      }

      if (taxonomy) {
        search_body.taxonomy = taxonomy;
      } else {
        search_body.ids = this.gopuff_product_ids;
      }

      return search_body;
    }

    async getGopuffData() {
      try {
        const searchBody = this.getSearchBody();
        const main_search_json_str = JSON.stringify(searchBody);
        const cacheQuery = (element) => element.query === main_search_json_str;
        const existingData = GopuffCollectionCarousel.cache.find(cacheQuery);

        if (existingData) {
          return existingData.products;
        }

        searchBody.shopify_shop_domain = Shopify.shop;
        const fetch_json_str = JSON.stringify(searchBody);
        const response = await fetch(`${window.gopuffShopify.settings.api_base_url}/shops/products`, { ...fetchConfig(), ...{ body: fetch_json_str } });
        const data = await response.json();
        const products = (data.products || []);

        GopuffCollectionCarousel.cache.push({ query: fetch_json_str, products });

        return products;
      } catch (err) {
        console.error(`error getting products for gopuff-collection-carousel`, err);
        gopuffCustomAnalytics.publishEndpointError(`/shops/products`);
        return [];
      }
    }

    getLoadingContent(placeholders_count = 6) {
      const loading_content = new DocumentFragment();

      for (let i = 0; i < placeholders_count; i++) {
        const placeholder_item = document.createElement(`li`);
        const placeholder_content = document.createElement(`div`);
        placeholder_item.classList.add(`grid__item`, `grid__item--placeholder`, `slider__slide`);
        placeholder_content.classList.add(`skeleton-box`);

        placeholder_item.appendChild(placeholder_content);
        loading_content.appendChild(placeholder_item);
      }

      return loading_content;
    }

    setLoading(isLoading = true) {
      this.classList.toggle(`gopuff-collection-carousel--loading`, isLoading);
      this.loading = isLoading;
    }

    renderCarousel() {
      const slides = new DocumentFragment();
      const slide_template = this.querySelector(`[data-slide-template]`);

      if (this.products.length === 0 && this.loading) {
        slides.appendChild(this.getLoadingContent());
      }

      this.products.forEach((product, product_index) => {
        const slide = slide_template.content.cloneNode(true);

        const updated_slide = modifyHTML(slide, (html_string) => {
          html_string = html_string.split(`[[ forloop_index ]]`).join(product_index);

          return html_string;
        });

        slides.appendChild(updated_slide);
      });

      const carousel = this.querySelector(`[data-carousel-template]`).content.cloneNode(true);
      carousel.querySelector(`[data-collection-carousel-products]`).appendChild(slides);
      this.querySelector(`[data-carousel-main]`).innerHTML = ``;
      this.querySelector(`[data-carousel-main]`).appendChild(carousel);

      this.querySelectorAll(`card-product`).forEach((card_product, product_index) => {
        card_product.setProduct(this.products[product_index]);
      });

      const section = this.closest('.section');
      if (section.classList.contains('hidden')) {
        section.classList.remove('hidden');
      }

      document.body.dispatchEvent(window.productsRenderedEvent)
    }

    renderEmpty() {
      this.querySelector(`[data-carousel-main]`).innerHTML = `<div class="gopuff-collection-carousel__empty">Sorry, we couldn't find any products</div>`;

      const section = this.closest('.section');
      if (section && this.hideSectionIfProductsEmpty) {
        section.classList.add('hidden');
      }
    }

    updateTitle({ titleWrapper, updatedTitleWrapper }) {
      const titleSelector = `[data-products-carousel-title]`;
      const titleEl = titleWrapper.querySelector(titleSelector);
      const newTitleEl = updatedTitleWrapper.querySelector(titleSelector);

      if (titleEl) {
        titleEl.remove();
      }

      titleWrapper.prepend(newTitleEl);
    }

    updateCta({ titleWrapper, updatedTitleWrapper }) {
      const ctaSelector = `[data-products-carousel-cta]`;
      const ctaEl = titleWrapper.querySelector(ctaSelector);
      const newCtaEl = updatedTitleWrapper.querySelector(ctaSelector);

      if (ctaEl) {
        ctaEl.remove();
      }

      titleWrapper.append(newCtaEl);
    }

    updateTitleWrapper({ title = ``, cta }) {
      if (!title && !cta) { return; }
      if (!this.section) { return; }

      const titleWrapper = this.section.querySelector(`[data-products-carousel-title-wrapper]`);
      const template = this.section.querySelector(`[data-gopuff-products-carousel-title-wrapper-template]`).content.cloneNode(true);
      const updatedTitleWrapper = modifyHTML(template, (htmlString) => {
        htmlString = htmlString.replaceAll(`[[ title ]]`, title);
        htmlString = htmlString.replaceAll(`[[ url ]]`, cta ? cta.url : ``);
        htmlString = htmlString.replaceAll(`[[ button_label ]]`, cta ? cta.text : ``);

        return htmlString;
      });

      if (title) {
        this.updateTitle({ titleWrapper, updatedTitleWrapper });
      }

      if (cta) {
        this.updateCta({ titleWrapper, updatedTitleWrapper });
      }
    }

    async loadProducts() {
      this.setLoading();
      this.renderCarousel();
      this.gopuff_product_ids = await this.getGopuffProductIds();
      this.products = await this.getGopuffData();

      const productsInStock = this.products.filter((product) => {
        return product.quantity > 0;
      });

      if (this.hideOutOfStockProducts) {
        this.products = productsInStock;
      }

      if ((this.products.length === 0) || (productsInStock.length === 0 && this.hideSectionIfProductsEmpty)) {
        this.renderEmpty();
      } else {
        this.renderCarousel();
      }

      if (this.breinifyRecommendation) {
        this.updateTitleWrapper(this.breinifyRecommendation);
      }

      this.setLoading(false);
    }

    connectedCallback() {
      this.loadProducts();
    }
  }

  GopuffCollectionCarousel.cache = [{ query: `{}`, products: [] }];
  GopuffCollectionCarousel.recommendationsCache = [{ query: `{}`, products: [] }];
  customElements.define(`gopuff-collection-carousel`, GopuffCollectionCarousel);

}
